import React, { Component } from "react";
import { connect } from "react-redux";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

//containers
import AdminWrapper from "../../containers/AdminWrapper";
import ContentWrapper from "../../containers/ContentWrapper";
//components
import AddShotShootSteppers from "./AddShotSteppers/AddShotShootSteppers";

class AddShotsSession extends Component {
  //TODO
  // add shot types in adding shot to session
  // check the query string if complete if not go back to shoots page

  render() {
    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title={`Add ${this.props.type === "photo" ? "Photo" : "Video"} Shots`}>
          <Grid container justify="center" alignItems="center">
            <Grid item md={12}>
              <Paper elevation={0}>
                <AddShotShootSteppers {...this.props} />
              </Paper>
            </Grid>
          </Grid>
        </ContentWrapper>
      </AdminWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    router: state.router.location
  };
};

export default connect(mapStateToProps)(AddShotsSession);
